import dateFnsFormat from 'date-fns/format';
import React from 'react';
import { LocaleConfigContext } from '../../../../contexts/locale-config/locale-config';
import { __ } from '../../../../utils/translation-service';
import { DateTypes } from '../../calendar/calendar';
import { StyledCalendarSVG } from '../../calendar/calendar.style';
import { getDateFormatByLocale } from '../../calendar/localization';
import { Input, InputSeparator, StyledCalendarWrapper, StyledInputWrapper } from './input.style';

interface IProps {
    startDate?: Date;
    endDate?: Date;
    onClick: (id: DateTypes) => void;
    className?: string;
}

export const CalendarInput = (props: IProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);
    const dateFormat = getDateFormatByLocale(localeConfig.code);
    const startDate = props.startDate ? dateFnsFormat(props.startDate, dateFormat) : '';
    const endDate = props.endDate ? dateFnsFormat(props.endDate, dateFormat) : '';

    return (
        <StyledCalendarWrapper className={props.className}>
            <StyledInputWrapper>
                <StyledCalendarSVG />
                <Input
                    type="text"
                    aria-label={__('startDatePlaceholder')}
                    id="START_DATE"
                    name="START_DATE"
                    value={startDate}
                    placeholder={__('startDatePlaceholder')}
                    autoComplete="off"
                    aria-describedby="DateInput__screen-reader-message-START_DATE"
                    onClick={() => props.onClick('startDate')}
                    readOnly
                />
            </StyledInputWrapper>
            <InputSeparator />
            <StyledInputWrapper>
                <StyledCalendarSVG second="true" />
                <Input
                    type="text"
                    aria-label={__('endDatePlaceholder')}
                    id="END_DATE"
                    name="END_DATE"
                    value={endDate}
                    placeholder={__('endDatePlaceholder')}
                    autoComplete="off"
                    aria-describedby="DateInput__screen-reader-message-END_DATE"
                    onClick={() => props.onClick('endDate')}
                    readOnly
                />
            </StyledInputWrapper>
        </StyledCalendarWrapper>
    );
};
